// 新媒体相关路由
export default {
  routes: [
    // 手机除尘
    {
      path: '/(\\s*)newMedia(\\d*)/(\\s*)dustRemoval(\\d*)',
      name: 'newMediaDustRemoval',
      meta: {
        title: '手机清灰'
      },
      component: () =>
        import(
          /* webpackChunkName: "newMediaDustRemoval" */ '../views/newMedia/dustRemoval/index.vue'
        )
    }
  ]
}
